<template lang="pug">
  v-row(no-gutters)
    v-col(cols="6")
      .text-sm.font-semibold.mb-1 {{ title }}
      .text-xs.mr-2(v-if="useBefore") Use before {{ useBefore | humanizeDate }}
    v-spacer
    v-col
      .d-flex.align-center
        div
          y-chip.py-1.px-3.round-3xl.success100.mb-1
            .text-xs.success700--text Active
          y-chip.py-1.px-3.round-3xl.neutral300
            v-icon(small) $yzi-alert-circle
            .text-xs.ml-1.no-wrap {{ redeemableQuantity }} left
        v-icon.ml-1(v-if="chevronRight") mdi-chevron-right
</template>

<script>
export default {
  props: {
    chevronRight: {
      type: Boolean,
    },
    title: {
      type: String,
      default: null
    },
    useBefore: {
      type: String,
      default: null
    },
    redeemableQuantity: {
      type: Number,
      default: 0
    },
  },
}
</script>

<style scoped>

</style>